// @ts-strict-ignore
import { ProjectGroupVO } from '../../../model/vo/project-group.vo';
import { ProjectOptionUtils } from '../../project/util/project-option.utils';
import { StringUtils } from '@shared/util/string-utils';
import { DrillingHoleInfo } from '@3d-scene/model3d/util/drillinghole/drilling-hole-info';
import { DrillingHoleSize } from '@3d-scene/model3d/util/drillinghole/drilling-hole-size';
import { RangeOnLineConnectionUtils } from '@3d-scene/model3d/util/range-on-line-connection-utils';
import { ParseProServeData } from '../../../processor/parse-pro-serve-data';
import { OldArticleNumberMappingVO } from '@article/model/vo/old-article-number-mapping.vo';
import { CompressionSimpleTextValueVO, ConnectionAreaVO, MetaElementUsageIdentityVO, MetaElementVO, SimpleTextValueVO, TableTextItemVO, TableTextRowVO, TableTextValueVO, TextureAreaUsageVO } from '@shared/vo/meta-element.vo';
import { OrderConnectionInformationVO } from '../../article/model/vo/order-connection-information.vo';
import { TextCheckSpacingData } from '@3d-scene/manager/text-check-spacing-data';
import { ProjectOptionDefVO, ProjectOptionVO } from '../../../model/vo/project.vo';
import { TextSizeCheckManager } from '@3d-scene/manager/text-size-check.manager';
import { TextSizeCheckUtils } from '@shared/util/text-size-check-utils';
import { TextSizeCheckVO } from '@3d-scene/manager/text-size-check.vo';
import { ArticleVO } from '@article/model/vo/article.vo';
import { NumberUtils } from '@shared/util/number-utils';
import { ProjectOptionDefIds } from '../../project/constants/project-option-def-ids';
import { ProjectType } from '../../../model/project-type';
import { HtmlUtils } from '@shared/util/html-utils';

export class ProServeProjectImportUtils {
  public static BREAK: string = 'break';
  private static PROJECT_ARTICLE: string = 'project-article';
  private static TARGET_PIN: string = 'target-pin';
  private static ARTICLE_NO_ATT: string = 'article-no';
  private static PROJECT_ARTICLE_ID: string = 'project-article-id';
  private static PROJECT_ARTICLE_OFFSET: string = 'project-article-offset';
  private static LENGTH: string = 'length';
  private static MARGIN_LOW: string = 'margin-lo';
  private static MARGIN_HIGH: string = 'margin-hi';
  private static BASE_PIN: string = 'base-pin';
  private static POLE: string = 'pole';
  private static ORDER: string = 'order';
  private static OFFSET: string = 'offset';
  private static TURNED: string = 'turned';
  private static LABEL_ORDER: string = 'label-order';
  private static ROTATION: string = 'rotation';
  private static FONT_NAME: string = 'font-name';
  private static FONT_SIZE: string = 'font-size';
  private static FONT_ITALIC: string = 'font-italic';
  private static FONT_UNDERLINE: string = 'font-underline';
  private static FONT_STRIKOUT: string = 'font-strikeout';
  private static LETTERINGSTRIPE: string = 'lettering-stripe';
  private static ALIGMENT: string = 'alignment';
  private static STRIPE_COUNT: string = 'stripe-count';
  private static RGB_COLOR: string = 'RGB-Color';
  private static LABEL: string = 'label';
  private static SHAPE: string = 'shape';
  private static POSITION: string = 'position';
  private static WIDTH: string = 'width';
  private static DRILL_DIMENSION_ID: string = 'DrillDimensionID';
  private static CORRECT_ARTICLE_POSTION: number = 10;
  private static PROJECT_CONNECTION: string = 'project-connection';

  public static uniqueArray(oldArray: string[]): string[] {
    if (oldArray) {
      const unique: string[] = [];
      for (let i: number = 0; i < oldArray.length; i++) {
        if (unique.indexOf(oldArray[i]) < 0) {
          unique.push(oldArray[i]);
        }
      }
      return unique;
    } else {
      return null;
    }
  }

  public static compareValues(toCompare: string, sortedArray: string[], compareBy: string = 'target-pin'): string[] {
    for (let i: number = 0; i < sortedArray.length; i++) {
      let sortedItem: string = sortedArray[i];
      let sortedItemObject: any = sortedItem[compareBy];
      let itemOffset: number = Number(sortedItemObject.offset);
      let toCompareItem: any = toCompare[compareBy];
      let ToCompareOffset: number = toCompareItem.offset;
      if (sortedArray[i + 1]) {
        const sortedItemAfter: string = sortedArray[i + 1];
        const sortedItemAfterObject: any = sortedItemAfter[compareBy];
        const itemAfterOffset: number = Number(sortedItemAfterObject.offset);
        toCompareItem = toCompare[compareBy];
        ToCompareOffset = toCompareItem.offset;
        if (itemOffset > ToCompareOffset && itemAfterOffset < ToCompareOffset) {
          sortedArray.splice(i + 1, 0, toCompare);
          break;
        } else if (i === 0 && itemOffset < ToCompareOffset) {
          sortedArray.splice(i, 0, toCompare);
          break;
        }
      } else {
        sortedItem = sortedArray[i];
        sortedItemObject = sortedItem[compareBy];
        itemOffset = Number(sortedItemObject.offset);
        toCompareItem = toCompare[compareBy];
        ToCompareOffset = toCompareItem.offset;
        if (itemOffset < ToCompareOffset) {
          sortedArray.splice(i, 0, toCompare);
          break;
        } else {
          sortedArray.push(toCompare);
          break;
        }
      }
    }
    return sortedArray;
  }

  public static sortDictionaryInArray(array: string[], compareBy: string = 'target-pin'): string[] {
    if (array) {
      const sortedArray: string[] = [];
      for (let i: number = 0; i < array.length; i++) {
        const compareItem: string = array[i];
        if (sortedArray.length === 0) {
          sortedArray.push(array[0]);
        } else if (sortedArray.length === 1) {
          const dic: string = sortedArray[0];
          const targetPin: any = dic[compareBy];
          const compareTarget: any = compareItem[compareBy];
          const offsetToCompare: number = Number(compareTarget.offset);
          const offsetArray: number = Number(targetPin.offset);
          if (offsetArray >= offsetToCompare) {
            sortedArray.push(array[i]);
          } else if (offsetArray < offsetToCompare) {
            sortedArray.splice(0, 0, array[i]);
          }
        } else {
          this.compareValues(compareItem, sortedArray, compareBy);
        }
      }
      return sortedArray;
    } else {
      return null;
    }
  }

  public static parseProjectMetaelement(xml: Document, projectName: string): Object {
    const changedMetaElementValues: any[] = [];
    const data: any = xml.childNodes;
    const tagData: any[] = [];
    const maxProjectOptionValueLength: number = ProjectOptionUtils.MAX_PROJECT_OPTION_VALUE_LENGTH;
    for (const item of data) {
      if (item) {
        const tag: string = item.localName;
        if (tag === 'OrderData' || tag === 'OrderAddresse' || tag === 'DeliveryAddresse' || tag === 'PersonInChargeAddress') {
          const tagInformation: any[] = [];
          for (const attr of item.attributes) {
            const attrName: string = String(attr.name);
            const attrValue: string = String(attr.value);
            const validatedAttrValue: string = attrValue.trim();
            tagInformation[attrName] = this.splitStringByMaxAllowedChar(validatedAttrValue, maxProjectOptionValueLength);
            const changedValuefirst: any = this.valueIsChanged(validatedAttrValue, tagInformation[attrName], projectName, attrName);
            if (changedValuefirst.metaElementName) {
              changedMetaElementValues.push(changedValuefirst);
            }
          }
          tagData[tag] = tagInformation;
          const subData: any = item.childNodes;
          if (subData) {
            for (const subXML of subData) {
              if (subXML.childNodes) {
                const subtag: string = subXML.localName;
                if (subtag === 'OrderData' || subtag === 'OrderAddresse' || subtag === 'DeliveryAddresse' || subtag === 'PersonInChargeAddress') {
                  const subtagInformation: string[] = [];
                  for (const subattr of subXML.attributes) {
                    const subattrName: string = String(subattr.name);
                    const subattrValue: string = String(subattr.value);
                    const validatedSubAttrValue: string = subattrValue.trim();
                    subtagInformation[subattrName] = this.splitStringByMaxAllowedChar(validatedSubAttrValue, maxProjectOptionValueLength);
                    const changedValuesecond = this.valueIsChanged(validatedSubAttrValue, subtagInformation[subattrName], projectName, subattrName);
                    if (changedValuesecond.metaElementName) {
                      changedMetaElementValues.push(changedValuesecond);
                    }
                  }
                  tagData[subtag] = subtagInformation;
                }
              }
            }
          }
        }
      }
    }
    return { metaElemnts: tagData, changesValues: changedMetaElementValues };
  }

  public static splitStringByMaxAllowedChar(value: string, maxAllowChar): string {
    if (!value || !maxAllowChar) {
      return '';
    }
    return StringUtils.getMaxCharsPerLine(value) > maxAllowChar ? value.substr(0, maxAllowChar) : value;
  }
  public static valueIsChanged(metaElementValue: string, newMetaElementValue: string, projectName: string, metaElemntName: string): any {
    const changedValueData: any = new Object();
    if (metaElementValue !== newMetaElementValue) {
      changedValueData.projectName = projectName;
      changedValueData.metaElementName = metaElemntName;
      changedValueData.metaElementValue = metaElementValue;
    }
    return changedValueData;
  }

  public static checkProjectNameExist(projects: ProjectGroupVO, projectName: string): string {
    let countSameName: number = 0;
    let projectNameFinal: string = '';
    if (!projects) {
      return projectName;
    }
    if (projects.projects) {
      if (projects.projects.length !== 0) {
        for (const projectHead of projects.projects) {
          if (projectHead.name.indexOf(projectName) !== -1) {
            countSameName++;
            projectNameFinal = projectName + '_' + String(countSameName);
          } else if (projectNameFinal === '' && projectHead.name.indexOf(projectName) === -1) {
            projectNameFinal = projectName;
          }
        }
      } else {
        projectNameFinal = projectName;
      }
    } else {
      projectNameFinal = projectName;
    }
    return projectNameFinal;
  }

  public static parseXMLData(xml: Document, symbolfontToSmartfontCharMapping: any): any {
    const childrenOfCurrentNode: any = xml.childNodes;
    const articlesForOneProject: string[] = [];
    const productionConnection: string[] = [];
    const mappingArticleNo: string[] = [];
    const xmltoArray: string[] = [];
    const tagsByProjectArticleId: string[] = [];
    const productionConnectionWithSameArticleID: string[] = [];
    const holesArray: DrillingHoleInfo[] = [];
    let copyHoles: DrillingHoleInfo[] = [];
    const _labelAttribute: any[] = [];
    let curentArticleLength: string;
    for (const childTag of childrenOfCurrentNode) {
      if (childTag) {
        switch (childTag.localName) {
          case this.PROJECT_ARTICLE:
            const currentarticleNo: string = childTag.attributes[this.ARTICLE_NO_ATT].value;
            const currentProjectTag: any = new Object();
            let marginLow: number = 0;
            let marginHigh: number = 0;
            const currentArticleID = childTag.attributes[this.PROJECT_ARTICLE_ID].value;
            const labels: string[] = [];
            currentProjectTag.articleNumber = childTag.attributes[this.ARTICLE_NO_ATT].value;
            currentProjectTag.articleID = currentArticleID;
            if (childTag.attributes[this.PROJECT_ARTICLE_OFFSET]) {
              currentProjectTag.offset = childTag.attributes[this.PROJECT_ARTICLE_OFFSET].value;
            }
            const childProject_Article: any = childTag.childNodes;
            for (const childInProject_Article of childProject_Article) {
              if (childInProject_Article.localName === this.LENGTH) {
                curentArticleLength = childInProject_Article.attributes.getNamedItem(this.LENGTH).value;
                if (!isNaN(parseFloat(childInProject_Article.attributes.getNamedItem(this.MARGIN_LOW).value))) {
                  marginLow = parseFloat(childInProject_Article.attributes.getNamedItem(this.MARGIN_LOW).value);
                }
                if (!isNaN(parseFloat(childInProject_Article.attributes.getNamedItem(this.MARGIN_HIGH).value))) {
                  marginHigh = parseFloat(childInProject_Article.attributes.getNamedItem(this.MARGIN_HIGH).value);
                }
                if (marginLow > 0 || marginHigh > 0) {
                  articlesForOneProject.push('BlockingZone');
                }
              } else if (childInProject_Article.localName === this.LABEL) {
                const label_Attribute: any = new Object();
                label_Attribute.pole = childInProject_Article.attributes.getNamedItem(this.POLE).value;
                label_Attribute.labelorder = childInProject_Article.attributes.getNamedItem(this.LABEL_ORDER).value;
                label_Attribute.rotation = childInProject_Article.attributes.getNamedItem(this.ROTATION).value;
                label_Attribute.fontname = childInProject_Article.attributes.getNamedItem(this.FONT_NAME).value;
                label_Attribute.fontsize = childInProject_Article.attributes.getNamedItem(this.FONT_SIZE).value;
                label_Attribute.fontbold = true; // font should in call cases be bold, no matter what it says in XML: NGI-182
                label_Attribute.fontitalic = childInProject_Article.attributes.getNamedItem(this.FONT_ITALIC) === 'true' ? true : false;
                label_Attribute.fontunderline = childInProject_Article.attributes.getNamedItem(this.FONT_UNDERLINE) === 'true' ? true : false;
                label_Attribute.fontstrikout = childInProject_Article.attributes.getNamedItem(this.FONT_STRIKOUT).value;
                label_Attribute.leterringstripe = childInProject_Article.attributes.getNamedItem(this.LETTERINGSTRIPE).value;
                label_Attribute.aligment = childInProject_Article.attributes.getNamedItem(this.ALIGMENT).value;
                label_Attribute.stripeCount = childInProject_Article.attributes.getNamedItem(this.STRIPE_COUNT).value;
                label_Attribute.rgbcolor = childInProject_Article.attributes.getNamedItem(this.RGB_COLOR).value;
                label_Attribute.val = this.getStringWithSymbolsMappedToSmartFont(
                  label_Attribute.fontname,
                  childInProject_Article.textContent,
                  symbolfontToSmartfontCharMapping
                );
                label_Attribute.val = this.getTrimmedStringFromLabelObject(label_Attribute);
                label_Attribute.val = this.getNormalizedLinesStringFromLabelObject(label_Attribute);
                label_Attribute.projectArticleId = currentArticleID;
                labels.push(label_Attribute);
                _labelAttribute[currentArticleID] = labels;
              } else if (childInProject_Article.localName === 'hole') {
                const hole_Attribute: DrillingHoleInfo = new DrillingHoleInfo();
                const drillingSize: DrillingHoleSize = new DrillingHoleSize();
                const position: number = Number(childInProject_Article.attributes.getNamedItem(this.POSITION).value);
                hole_Attribute.position = Number(position * this.CORRECT_ARTICLE_POSTION);
                hole_Attribute.positionOffset = RangeOnLineConnectionUtils.getHalfStretchLengthInAwayUnits();
                if (childInProject_Article.attributes.getNamedItem(this.SHAPE).value === 'roundrect') {
                  hole_Attribute.shapeType = 'slot';
                  drillingSize.sizeLabel =
                    childInProject_Article.attributes.getNamedItem(this.LENGTH).value +
                    DrillingHoleSize.SIZE_SEPARATOR +
                    childInProject_Article.attributes.getNamedItem(this.WIDTH).value;
                } else if (childInProject_Article.attributes.getNamedItem(this.SHAPE).value === 'square') {
                  drillingSize.sizeLabel =
                    childInProject_Article.attributes.getNamedItem(this.LENGTH).value +
                    DrillingHoleSize.SIZE_SEPARATOR +
                    childInProject_Article.attributes.getNamedItem(this.WIDTH).value;
                  hole_Attribute.shapeType = childInProject_Article.attributes.getNamedItem(this.SHAPE).value;
                } else if (childInProject_Article.attributes.getNamedItem(this.SHAPE).value === 'round') {
                  drillingSize.sizeLabel = childInProject_Article.attributes.getNamedItem('diameter').value;
                  hole_Attribute.shapeType = 'circle';
                }
                hole_Attribute.usageId = null;
                hole_Attribute.drillDimmensionID = Number(childInProject_Article.attributes.getNamedItem(this.DRILL_DIMENSION_ID).value);
                hole_Attribute.size = drillingSize;
                holesArray.push(hole_Attribute);
                copyHoles = holesArray;
              }
            }
            currentProjectTag.marginLow = marginLow;
            currentProjectTag.marginHigh = marginHigh;
            currentProjectTag.length = curentArticleLength;
            mappingArticleNo[currentArticleID] = currentarticleNo;
            xmltoArray[currentarticleNo] = currentProjectTag;
            tagsByProjectArticleId[currentArticleID] = currentProjectTag;
            articlesForOneProject.push(currentarticleNo);
            break;
          case this.PROJECT_CONNECTION:
            const base_target_Tag: any = childTag.childNodes;
            const current_Connection: any = [];
            let current_ProjectArticleID = '';
            const projectConnectionArray: string[] = [];
            for (const tag of base_target_Tag) {
              switch (tag.localName) {
                case this.BASE_PIN: {
                  const tagObject: any = new Object();
                  tagObject.projectArticleID = tag.attributes[this.PROJECT_ARTICLE_ID].value;
                  tagObject.pole = tag.attributes[this.POLE].value;
                  tagObject.order = tag.attributes[this.ORDER].value;
                  if (tag.attributes[this.OFFSET]) {
                    tagObject.offset = tag.attributes[this.OFFSET].value;
                  }
                  tagObject.turned = tag.attributes[this.TURNED].value;
                  current_Connection[this.BASE_PIN] = tagObject;
                  current_ProjectArticleID = tag.attributes[this.PROJECT_ARTICLE_ID].value;
                  break;
                }
                case this.TARGET_PIN: {
                  const tagObject: any = new Object();
                  tagObject.projectArticleID = tag.attributes[this.PROJECT_ARTICLE_ID].value;
                  tagObject.pole = tag.attributes[this.POLE].value;
                  tagObject.order = tag.attributes[this.ORDER].value;
                  if (tag.attributes[this.OFFSET]) {
                    tagObject.offset = Number(tag.attributes[this.OFFSET].value);
                  }
                  tagObject.turned = tag.attributes[this.TURNED].value;
                  current_Connection[this.TARGET_PIN] = tagObject;
                  break;
                }
              }
            }
            if (!productionConnectionWithSameArticleID[current_ProjectArticleID]) {
              projectConnectionArray.push(current_Connection);
              productionConnectionWithSameArticleID[current_ProjectArticleID] = projectConnectionArray;
              productionConnection.push(current_Connection);
            } else {
              const productionConnections: string[] = productionConnectionWithSameArticleID[current_ProjectArticleID];
              productionConnections.push(current_Connection);
              productionConnectionWithSameArticleID[current_ProjectArticleID] = productionConnections;
            }
            break;
        }
      }
    }
    const parseXmlData: ParseProServeData = new ParseProServeData(
      productionConnection,
      articlesForOneProject,
      mappingArticleNo,
      xmltoArray,
      tagsByProjectArticleId,
      productionConnectionWithSameArticleID,
      copyHoles,
      _labelAttribute
    );
    return parseXmlData;
  }
  private static getStringWithSymbolsMappedToSmartFont(fontName: string, text: string, symbolfontToSmartfontCharMapping: any): string {
    if (!text) {
      return null;
    }
    let mappedSymbole: string = '';
    if (fontName === 'WAGO Symbolfont') {
      for (let i: number = 0; i < text.length; i++) {
        const mappedCharCodeString: string = symbolfontToSmartfontCharMapping[text.charCodeAt(i).toString()]; // this.localeResourceManager.getValueByKey(text.charCodeAt(i).toString(), 'wago_symbolfont_to_smartfont_char_mapping');
        let mappedCharCodeNumber: number = NaN;
        if (mappedCharCodeString) {
          mappedCharCodeNumber = parseInt(mappedCharCodeString, 16);
        }
        if (!isNaN(mappedCharCodeNumber)) {
          mappedSymbole += String.fromCharCode(mappedCharCodeNumber);
        } else {
          mappedSymbole += text.charAt(i);
        }
      }
    } else {
      mappedSymbole = text;
    }
    return mappedSymbole;
  }

  private static getNormalizedLinesStringFromLabelObject(obj: any): string {
    let text: string = obj && obj.val ? obj.val : '';
    text = StringUtils.replaceAll(text, '\r\n', '\n');
    return text;
  }

  private static getTrimmedStringFromLabelObject(obj: any): string {
    const text: string = obj ? obj.val : '';
    return this.getTrimmedString(text);
  }

  private static getTrimmedString(text: string): string {
    let trimmedValue: string = !text ? '' : text;
    const spacesStart: RegExp = /^ /gi;
    const spacesEnd: RegExp = /$ /gi;
    trimmedValue = trimmedValue.replace(spacesStart, '');
    trimmedValue = trimmedValue.replace(spacesEnd, '');
    return trimmedValue;
  }

  public static convertmappedArticleNoArrayToDictionary(mappedArticleNumber: OldArticleNumberMappingVO[]): OldArticleNumberMappingVO[] {
    const mappedArticleNumberDictionary: OldArticleNumberMappingVO[] = [];
    for (const articleNumber of mappedArticleNumber) {
      if (!articleNumber) {
        continue;
      }
      mappedArticleNumberDictionary[articleNumber.oldArticleNumber] = articleNumber;
    }
    return mappedArticleNumberDictionary;
  }

  public static replaceOldArticleNumbersWithMappedArticleNumbers(
    projectArticleNumbers: string[],
    mappedArticleNumbers: OldArticleNumberMappingVO[]
  ): string[] {
    for (const i in projectArticleNumbers) {
      if (mappedArticleNumbers[projectArticleNumbers[i]]) {
        const currentmappedArticleNumber: OldArticleNumberMappingVO = mappedArticleNumbers[projectArticleNumbers[i]];
        projectArticleNumbers[i] = currentmappedArticleNumber.newArticleNumber;
      }
    }
    return projectArticleNumbers;
  }

  public static replaceOldArticleNumbersArrayWithMappedArticleNumbers(
    projectArticleNumbers: string[],
    mappedArticleNumbers: OldArticleNumberMappingVO[]
  ): string[] {
    for (let i: number = 0; i < projectArticleNumbers.length; i++) {
      if (mappedArticleNumbers[projectArticleNumbers[i]]) {
        const oldArticleNumberMapping: OldArticleNumberMappingVO = mappedArticleNumbers[projectArticleNumbers[i]];
        projectArticleNumbers[i] = oldArticleNumberMapping.newArticleNumber;
      }
    }
    return projectArticleNumbers;
  }

  public static getOldMountingRailNumber(articleNumber: string, convertedmappedArticleNoArrayToDictionary: any): string {
    let oldMountingrailnumber: string = '';
    for (const key in convertedmappedArticleNoArrayToDictionary) {
      if (convertedmappedArticleNoArrayToDictionary.hasOwnProperty(key)) {
        const oldArticleNumberMapping: OldArticleNumberMappingVO = convertedmappedArticleNoArrayToDictionary[key];
        if (oldArticleNumberMapping.newArticleNumber === articleNumber) {
          oldMountingrailnumber = key;
        }
      }
    }
    return oldMountingrailnumber !== '' ? oldMountingrailnumber : articleNumber;
  }

  public static findProjectType(articleNumber: string): ProjectType | undefined {
    let typeProject = undefined;
    if (this.isTSProject(articleNumber)) {
      typeProject = "MOUNTING_RAIL";
    } else if (this.isTSFreeMounting(articleNumber)) {
      typeProject = "FREE_MOUNTING";
    } else if (this.isSpeedwayProject(articleNumber)) {
      typeProject = "SPEEDWAY";
    } else if (this.isLeiterPlattenProject(articleNumber)) {
      typeProject = "CIRCUIT_BOARD";
    }
    return typeProject;
  }

  public static isTSProject(searchString: string): boolean {
    //ich denke bis 4 dezimal würden reichen, aber da ich die genauen Werte nicht kenne nehme ich bis 10
    const pattern: RegExp = /(\d{1,10})-(\w){1,10}(\/?)(\d{0,10})/;
    const result: Object = pattern.exec(searchString);
    if (!result) {
      return false;
    }
    return true;
  }

  private static isTSFreeMounting(searchString: string): boolean {
    const pattern: RegExp = /(all connection types)(\w*)/;
    const result: Object = pattern.exec(searchString);
    if (!result) {
      return false;
    }
    return true;
  }

  private static isSpeedwayProject(searchString: string): boolean {
    const pattern: RegExp = /(WAGO SPEEDWAY 767)(\w*)/;
    const result: Object = pattern.exec(searchString);
    if (!result) {
      return false;
    }
    return true;
  }

  private static isLeiterPlattenProject(searchString: string): boolean {
    const pattern: RegExp = /(\w)+/;
    const result: Object = pattern.exec(searchString);
    if (!result) {
      return false;
    }
    return true;
  }

  public static getMountingRailArticleNobyNoExistArticleVO(allArticleNumber: any[], foundedArticleNumber: ArticleVO[]): string {
    let mountingRailArticleNumber: string = '';
    for (const articleNumber of allArticleNumber) {
      if (foundedArticleNumber.indexOf(articleNumber) < 0) {
        mountingRailArticleNumber = articleNumber;
        break;
      }
    }
    return mountingRailArticleNumber;
  }

  public static filterDrillingHolesByLengthOfMountingRail(drillingHoles: DrillingHoleInfo[], moutingRailLength: number): any {
    const filterdDrillingHoles: DrillingHoleInfo[] = [];
    for (const hole of drillingHoles) {
      switch (hole.shapeType) {
        case 'slot': {
          if (hole.position <= moutingRailLength) {
            filterdDrillingHoles.push(hole);
          } else {
            const holeSize: DrillingHoleSize = hole.size;
            const holeLengthWidth = holeSize.sizeLabel.split('x');
            const holeLength: number = parseInt(holeLengthWidth[0], 10);
            if (hole.position - holeLength * 10 <= moutingRailLength) {
              filterdDrillingHoles.push(hole);
            }
          }
          break;
        }
        case 'square': {
          if (hole.position <= moutingRailLength) {
            filterdDrillingHoles.push(hole);
          } else {
            const holeSize: DrillingHoleSize = hole.size;
            const holeLengthWidth = holeSize.sizeLabel.split('x');
            const holeLength: number = parseInt(holeLengthWidth[0], 10);
            if (hole.position - holeLength * 10 <= moutingRailLength) {
              filterdDrillingHoles.push(hole);
            }
          }
          break;
        }
        case 'round': {
          if (hole.position <= moutingRailLength) {
            filterdDrillingHoles.push(hole);
          } else {
            const holeSize: DrillingHoleSize = hole.size;
            const holeLengthWidth = holeSize.sizeLabel;
            const holeLength: number = parseInt(holeLengthWidth, 10);
            if (hole.position - holeLength * 10 <= moutingRailLength) {
              filterdDrillingHoles.push(hole);
            }
          }
          break;
        }
        case 'circle': {
          if (hole.position <= moutingRailLength) {
            filterdDrillingHoles.push(hole);
          } else {
            const holeSize: DrillingHoleSize = hole.size;
            const holeLengthWidth = holeSize.sizeLabel;
            const holeLength: number = parseInt(holeLengthWidth, 10);
            if (hole.position - holeLength * 10 <= moutingRailLength) {
              filterdDrillingHoles.push(hole);
            }
          }
          break;
        }
        default: {
          break;
        }
      }
    }
    return filterdDrillingHoles;
  }

  public static getMetaElementName(metaElements: MetaElementVO[], orderNumber: string): string {
    for (const metaElement of metaElements) {
      if (metaElement instanceof ConnectionAreaVO) {
        if (metaElement.orderNumber === parseInt(orderNumber, 10)) {
          return metaElement.name;
        }
      }
    }
    return '';
  }

  public static getAlternativeOrderConnection(
    orderNumber: number,
    articleNumber: string,
    alternativeOrderNumbers: OrderConnectionInformationVO[]
  ): number {
    if (alternativeOrderNumbers) {
      for (const orderConnectionInformation of alternativeOrderNumbers) {
        if (orderConnectionInformation.orderNumber === orderNumber && orderConnectionInformation.articleNumber === articleNumber) {
          return orderConnectionInformation.alternativeOrderConnectionNumber;
        }
      }
    }
    return NaN;
  }

  public static sortSameProductionConnection(array: string[], ProductionConnectionWithSameArticleID: any): any[] {
    const sortedArray: any[] = [];
    for (let i: number = 0; i < array.length; i++) {
      const compareItem: any = array[i];
      if (sortedArray.length === 0) {
        sortedArray.push(array[0]);
      } else if (sortedArray.length === 1) {
        const dic: any = sortedArray[0];
        const targetPin: any = dic['target-pin'];
        const targetPinID: string = targetPin.projectArticleID;
        const compareTarget: any = compareItem['target-pin'];
        const compreTragetID: string = compareTarget.projectArticleID;
        const offsetToCompare: number = Number(this.getOffsetOfProductionConnection(ProductionConnectionWithSameArticleID[compreTragetID]));
        const offsetArray: number = Number(this.getOffsetOfProductionConnection(ProductionConnectionWithSameArticleID[targetPinID]));
        if (offsetArray >= offsetToCompare) {
          sortedArray.push(array[i]);
        } else if (offsetArray < offsetToCompare) {
          sortedArray.splice(0, 0, array[i]);
        }
      } else {
        this.compareSameProductionConnection(compareItem, sortedArray, ProductionConnectionWithSameArticleID);
      }
    }
    return sortedArray;
  }

  public static getOffsetOfProductionConnection(productionConnections: any[]): string {
    const productionConnection: any = productionConnections[0];
    const basePin: any = productionConnection['target-pin'];
    const offset: string = basePin.offset;
    return offset;
  }

  public static compareSameProductionConnection(toCompare: any, sortedArray: any[], ProductionConnectionWithSameArticleID: any): any[] {
    for (let i: number = 0; i < sortedArray.length; i++) {
      const sortedItem: any = sortedArray[i];
      const sortedItemObject: any = sortedItem['target-pin'];
      const sortedItemObjectID: string = sortedItemObject.projectArticleID;
      const itemOffset: number = Number(this.getOffsetOfProductionConnection(ProductionConnectionWithSameArticleID[sortedItemObjectID]));
      const toCompareItem: any = toCompare['target-pin'];
      const toComprareItemID = toCompareItem.projectArticleID;
      const ToCompareOffset: number = Number(this.getOffsetOfProductionConnection(ProductionConnectionWithSameArticleID[toComprareItemID]));
      if (sortedArray[i + 1]) {
        const sortedItemAfter: any = sortedArray[i + 1];
        const sortedItemAfterObject: any = sortedItemAfter['target-pin'];
        const sortedItemAfterObjectID: string = sortedItemAfterObject.projectArticleID;
        const itemAfterOffset: number = Number(this.getOffsetOfProductionConnection(ProductionConnectionWithSameArticleID[sortedItemAfterObjectID]));
        if (itemOffset > ToCompareOffset && itemAfterOffset < ToCompareOffset) {
          sortedArray.splice(i + 1, 0, toCompare);
          break;
        } else if (i === 0 && itemOffset < ToCompareOffset) {
          sortedArray.splice(i, 0, toCompare);
          break;
        }
      } else {
        if (itemOffset < ToCompareOffset) {
          sortedArray.splice(i, 0, toCompare);
          break;
        } else {
          sortedArray.push(toCompare);
          break;
        }
      }
    }
    return sortedArray;
  }

  public static getGivingConnectionVo(metaElements: MetaElementVO[], orderNumber: number, pole: number): ConnectionAreaVO {
    /*
			TODO DL: Enable once fully clearified
			for each(var metaelement:* in metaElements)
			{
				if (metaelement is ConnectionAreaVO && hasGivingConnectionSide(metaelement as ConnectionAreaVO))
				{
					if ((metaelement as ConnectionAreaVO).orderNumber === orderNumber && (metaelement as ConnectionAreaVO).corridor === pole)
					{
						return metaelement as ConnectionAreaVO;
					}
				}
			}
      */
    // if nothing was found, try again without observing corridor
    for (const metaelement of metaElements) {
      if (metaelement instanceof ConnectionAreaVO && this.hasGivingConnectionSide(metaelement)) {
        if (metaelement.orderNumber === orderNumber) {
          return metaelement;
        }
      }
    }
    return null;
  }

  public static hasGivingConnectionSide(connectionArea: ConnectionAreaVO): boolean {
    if (connectionArea && connectionArea.connectionSide === ConnectionAreaVO.SIDE_GIVING) {
      return true;
    }
    return false;
  }

  public static checkObjectExist(array: any[], element: string): boolean {
    let result: boolean = true;
    for (const obj of array) {
      if (obj.projectArticleId === element) {
        result = false;
        break;
      } else {
        result = true;
      }
    }
    return result;
  }

  public static getRotationByPath(itemId: string, connectionDictionary: string[]): boolean {
    let result: boolean = false;
    if (!itemId || !connectionDictionary) {
      return result;
    }
    const connections: string[] = connectionDictionary[itemId];
    if (!connections || connections.length < 1) {
      return result;
    }
    for (const connection of connections) {
      const targetID: string = connection['target-pin']['projectArticleID'];
      const rotated: boolean = StringUtils.parseBoolean(connection['base-pin']['turned']);
      const parentRotation: boolean = this.getRotationByPath(targetID, connectionDictionary);
      if ((rotated || parentRotation) && !(rotated && parentRotation)) {
        result = true;
      }
    }
    return result;
  }

  public static preProcessLabel(
    currentLabels: any[],
    textureAreaUsages: TextureAreaUsageVO[],
    toDeleteLabel: number[],
    globalToDeleteLabel: number[],
    projectArticleIdToRailPosData: any[],
    railPosToTextCheckSpacingData: any[]
  ) {
    const projectArticleIdToPosCounter: number[] = [];
    currentLabels.forEach((row: any) => {
      if (row) {
        for (let i: number = 0; i < row.length; i++) {
          const label = row[i];
          let currentPos = null;
          let currentTextCheckSpacingData: TextCheckSpacingData = null;
          if (projectArticleIdToPosCounter.hasOwnProperty(label.projectArticleId)) {
            currentPos = projectArticleIdToPosCounter[label.projectArticleId];
            currentTextCheckSpacingData = railPosToTextCheckSpacingData.hasOwnProperty(currentPos) ? railPosToTextCheckSpacingData[currentPos] : null;
          } else {
            const railPosData = projectArticleIdToRailPosData[label.projectArticleId];
            if (railPosData) {
              if (railPosData instanceof Array) {
                let minRailPosData: any = null;
                for (const posData of railPosData) {
                  if (minRailPosData === null || posData.railPos < minRailPosData.railPos) {
                    minRailPosData = posData;
                  }
                }
                currentPos = minRailPosData.railPos;
                currentTextCheckSpacingData = minRailPosData.textCheckSpacingData;
              } else {
                currentPos = railPosData.railPos;
                currentTextCheckSpacingData = railPosData.textCheckSpacingData;
              }
            }
          }
          label.railPos = currentPos;
          label.textCheckSpacingData = currentTextCheckSpacingData;
          currentPos++;
          projectArticleIdToPosCounter[label.projectArticleId] = currentPos;
        }
      }
    });
    const indexToStripCount: number[] = [];
    for (const rowKey in currentLabels) {
      if (currentLabels.hasOwnProperty(rowKey)) {
        let row: number[] = currentLabels[rowKey];
        row = this.deleteMarkedLabels(row, toDeleteLabel, globalToDeleteLabel);
        if (row) {
          for (let colIndex = 0; colIndex < row.length; colIndex++) {
            const label: any = row[colIndex];
            const labelIndex: number = colIndex;
            const ignoreLabel: number = this.getCountOfSpannedDeletedLabels(toDeleteLabel, label, globalToDeleteLabel);
            const stripCount: number = Number(label.stripeCount) - ignoreLabel;
            indexToStripCount[labelIndex] = stripCount;
            if (stripCount > 0) {
              for (let z: number = 0; z < stripCount; z++) {
                let currentTextureAreaUsage: TextureAreaUsageVO;
                let nextTextureAreaUsage: TextureAreaUsageVO;
                let previousTextureAreaUsage: TextureAreaUsageVO;
                let identity: MetaElementUsageIdentityVO;
                if (z === 0) {
                  currentTextureAreaUsage = textureAreaUsages[colIndex];
                  nextTextureAreaUsage = textureAreaUsages[colIndex + 1];
                  if (!nextTextureAreaUsage) {
                    continue;
                  }
                  identity = nextTextureAreaUsage.identity;
                  currentTextureAreaUsage.nextMergedUsageId = identity;
                } else if (z === stripCount - 1) {
                  currentTextureAreaUsage = textureAreaUsages[colIndex + z];
                  previousTextureAreaUsage = textureAreaUsages[colIndex + z - 1];
                  if (!previousTextureAreaUsage) {
                    continue;
                  }
                  identity = previousTextureAreaUsage.identity;
                  if (!currentTextureAreaUsage) {
                    continue;
                  }
                  currentTextureAreaUsage.previousMergedUsageId = identity;
                } else if (z < stripCount - 1) {
                  currentTextureAreaUsage = textureAreaUsages[colIndex + z];
                  nextTextureAreaUsage = textureAreaUsages[colIndex + z + 1];
                  if (!nextTextureAreaUsage) {
                    continue;
                  }
                  previousTextureAreaUsage = textureAreaUsages[colIndex + z - 1];
                  currentTextureAreaUsage.nextMergedUsageId = nextTextureAreaUsage.identity;
                  currentTextureAreaUsage.previousMergedUsageId = previousTextureAreaUsage.identity;
                }
              }
            } else if (stripCount < 0) {
              break;
            }
            if (stripCount > 0) {
              colIndex = colIndex + stripCount - 1;
            }
          }
        }
      }
    }
  }

  private static getCountOfSpannedDeletedLabels(localToDeleteLabels: number[], label: any, globalToDeleteLabels: number[]): number {
    let startPos: number = null;
    let endPos: number = null;
    if (!label) {
      return 0;
    }
    if ((!localToDeleteLabels || localToDeleteLabels.length === 0) && (!globalToDeleteLabels || globalToDeleteLabels.length === 0)) {
      return 0;
    }
    if (localToDeleteLabels) {
      startPos = Number(label.labelorder);
      endPos = startPos + Math.max(Number(label.stripeCount), 1) - 1;
      if (startPos === endPos && startPos && endPos) {
        return 0;
      }
      let count: number = 0;
      for (const pos of localToDeleteLabels) {
        if (pos > startPos && pos < endPos) {
          count++;
        }
      }
      return count;
    } else {
      startPos = label.railPos;
      endPos = startPos + Math.max(Number(label.stripeCount), 1) - 1;
      if (startPos === endPos && startPos && endPos) {
        return 0;
      }
      let count: number = 0;
      for (const pos of globalToDeleteLabels) {
        if (pos > startPos && pos < endPos) {
          count++;
        }
      }
      return count;
    }
  }

  private static deleteMarkedLabels(labels: any[], localToDeleteLabels: any[], globalToDeleteLabels: any[]): any[] {
    if (!labels || labels.length === 0) {
      return labels;
    }
    if ((!localToDeleteLabels || localToDeleteLabels.length === 0) && (!globalToDeleteLabels || globalToDeleteLabels.length === 0)) {
      return labels;
    }
    const result: any[] = [];
    for (let i: number = 0; i < labels.length; i++) {
      const label = labels[i];
      if (localToDeleteLabels) {
        if (localToDeleteLabels.indexOf(i + 1) < 0) {
          result.push(label);
        }
      } else {
        if (globalToDeleteLabels.indexOf(label.railPos) < 0) {
          result.push(label);
        }
      }
    }
    return result;
  }

  public static dictionaryLength(myDictionary: any): number {
    let n: number = 0;
    for (const key in myDictionary) {
      if (myDictionary.hasOwnProperty(key)) {
        n++;
      }
    }
    return n;
  }

  public static findParentGroupByGroupNameAndGroupType(
    projectGroup: ProjectGroupVO,
    carrierParentGroup: string,
    groupType: number = null
  ): ProjectGroupVO {
    const carrierParentGroupString: string = carrierParentGroup;
    let groupProject: ProjectGroupVO = null;
    if (projectGroup.groupName !== carrierParentGroupString || (NumberUtils.isNumber(groupType) && groupType !== projectGroup.groupType)) {
      for (const group of projectGroup.groups) {
        if (group.groupName === carrierParentGroupString && (NumberUtils.isNotNumber(groupType) || groupType === group.groupType)) {
          groupProject = group;
          break;
        } else {
          const tempParentGroup: ProjectGroupVO = this.findParentGroupByGroupNameAndGroupType(group, carrierParentGroupString, groupType);
          if (tempParentGroup) {
            groupProject = tempParentGroup;
          }
        }
      }
    } else {
      groupProject = projectGroup;
    }
    return groupProject;
  }

  public static setProjectMetaElement(projectOptionDefs: ProjectOptionDefVO[], projectMetaData: any): ProjectOptionVO[] {
    const currentProjectOptions: ProjectOptionVO[] = [];
    projectOptionDefs.sort((a: ProjectOptionDefVO, b: ProjectOptionDefVO) => a.order - b.order);
    const convertedProjectOptionDefs: ProjectOptionVO[] = ProjectOptionUtils.convertProjectOptionDefsToProjectOptions(projectOptionDefs);
    for (const projectmeta in projectMetaData) {
      if (!projectMetaData.hasOwnProperty(projectmeta)) continue;
      const projectOptionMeta: any[] = projectMetaData[projectmeta];

      for (const meta in projectOptionMeta) {
        if (!projectOptionMeta.hasOwnProperty(meta)) continue;

        const projectOption: ProjectOptionVO = ProjectOptionUtils.findProjectOptionByIdentifier(
          convertedProjectOptionDefs,
          this.getProjectOptionIdentifierForMetaData(meta, projectmeta)
        );

        if (!projectOption) continue

        if (projectOption.identifier === ProjectOptionDefIds.REMARK_ID) {
          projectOption.value = ProjectOptionUtils.getCleanedProjectOptionValue(projectOptionMeta[meta]);
        } else {
          projectOption.value = projectOptionMeta[meta];
        }
        currentProjectOptions.push(projectOption);
      }
    }
    return currentProjectOptions;
  }

  public static getProjectMetaElementValue(projectMetaData: any, category: string, elementName: string): string {
    let metaElementValue: string = '';
    if (!projectMetaData || !category || !elementName) {
      return null;
    }
    const maxProjectOptionValueLength: number = ProjectOptionUtils.MAX_PROJECT_OPTION_VALUE_LENGTH;
    const metaData: string = projectMetaData[category][elementName];
    if (StringUtils.getMaxCharsPerLine(metaData) > maxProjectOptionValueLength) {
      metaElementValue = metaData.substr(0, maxProjectOptionValueLength);
    } else {
      metaElementValue = metaData;
    }
    return metaElementValue;
  }

  private static getProjectOptionIdentifierForMetaData(metaData: string, category: string): string {
    let newMetaElement: string = null;
    switch (metaData) {
      case 'ProjectGroup': {
        newMetaElement = null;
        break;
      }
      case 'Project': {
        newMetaElement = null;
        break;
      }
      case 'Drawing': {
        newMetaElement = null;
        break;
      }
      case 'Location': {
        newMetaElement = null;
        break;
      }
      case 'Carrier': {
        newMetaElement = null;
        break;
      }
      case 'Plant': {
        newMetaElement = null;
        break;
      }
      case 'AddrID': {
        if (category === 'OrderAddresse') {
          newMetaElement = null;
        } else if (category === 'DeliveryAddresse') {
          newMetaElement = null;
        } else if (category === 'PersonInChargeAddress') {
          newMetaElement = null;
        }
        break;
      }
      case 'CustNo': {
        if (category === 'OrderAddresse') {
          newMetaElement = '14';
        } else if (category === 'DeliveryAddresse') {
          newMetaElement = '29';
        } else if (category === 'PersonInChargeAddress') {
          newMetaElement = '42';
        }
        break;
      }
      case 'Salutation': {
        if (category === 'OrderAddresse') {
          newMetaElement = '15';
        } else if (category === 'DeliveryAddresse') {
          newMetaElement = '30';
        } else if (category === 'PersonInChargeAddress') {
          newMetaElement = '43';
        }
        break;
      }
      case 'Name': {
        if (category === 'OrderAddresse') {
          newMetaElement = '16';
        } else if (category === 'DeliveryAddresse') {
          newMetaElement = '31';
        } else if (category === 'PersonInChargeAddress') {
          newMetaElement = '44';
        }
        break;
      }
      case 'Firma': {
        if (category === 'OrderAddresse') {
          newMetaElement = '17';
        } else if (category === 'DeliveryAddresse') {
          newMetaElement = '32';
        } else if (category === 'PersonInChargeAddress') {
          newMetaElement = '45';
        }
        break;
      }
      case 'Street1': {
        if (category === 'OrderAddresse') {
          newMetaElement = '18';
        } else if (category === 'DeliveryAddresse') {
          newMetaElement = '33';
        } else if (category === 'PersonInChargeAddress') {
          newMetaElement = '46';
        }
        break;
      }
      case 'Street2': {
        if (category === 'OrderAddresse') {
          newMetaElement = '19';
        } else if (category === 'DeliveryAddresse') {
          newMetaElement = '34';
        } else if (category === 'PersonInChargeAddress') {
          newMetaElement = '47';
        }
        break;
      }
      case 'Zip': {
        if (category === 'OrderAddresse') {
          newMetaElement = '20';
        } else if (category === 'DeliveryAddresse') {
          newMetaElement = '35';
        } else if (category === 'PersonInChargeAddress') {
          newMetaElement = '48';
        }
        break;
      }
      case 'City1': {
        if (category === 'OrderAddresse') {
          newMetaElement = '21';
        } else if (category === 'DeliveryAddresse') {
          newMetaElement = '36';
        } else if (category === 'PersonInChargeAddress') {
          newMetaElement = '49';
        }
        break;
      }
      case 'City2': {
        if (category === 'OrderAddresse') {
          newMetaElement = null;
        } else if (category === 'DeliveryAddresse') {
          newMetaElement = null;
        } else if (category === 'PersonInChargeAddress') {
          newMetaElement = null;
        }
        break;
      }
      case 'Country': {
        if (category === 'OrderAddresse') {
          newMetaElement = '22';
        } else if (category === 'DeliveryAddresse') {
          newMetaElement = '37';
        } else if (category === 'PersonInChargeAddress') {
          newMetaElement = '50';
        }
        break;
      }
      case 'Phone': {
        if (category === 'OrderAddresse') {
          newMetaElement = '23';
        } else if (category === 'DeliveryAddresse') {
          newMetaElement = '38';
        } else if (category === 'PersonInChargeAddress') {
          newMetaElement = '51';
        }
        break;
      }
      case 'Abteilung': {
        newMetaElement = '24';
        break;
      }
      case 'Funktion': {
        newMetaElement = '25';
        break;
      }
      case 'Fax': {
        if (category === 'OrderAddresse') {
          newMetaElement = '26';
        } else if (category === 'DeliveryAddresse') {
          newMetaElement = '39';
        } else if (category === 'PersonInChargeAddress') {
          newMetaElement = '52';
        }
        break;
      }
      case 'Email': {
        if (category === 'OrderAddresse') {
          newMetaElement = '27';
        } else if (category === 'DeliveryAddresse') {
          newMetaElement = '40';
        } else if (category === 'PersonInChargeAddress') {
          newMetaElement = '53';
        }
        break;
      }
      case 'Designer': {
        newMetaElement = '1';
        break;
      }
      case 'Notice': {
        newMetaElement = '3';
        break;
      }
      case 'Currency_ID': {
        newMetaElement = null;
        break;
      }
      case 'Language_ID': {
        newMetaElement = null;
        break;
      }
      case 'Referenz': {
        newMetaElement = null;
        break;
      }
      case 'SignNo': {
        newMetaElement = '4';
        break;
      }
      case 'ItemNo': {
        newMetaElement = null;
        break;
      }
      case 'LongArticleNo': {
        newMetaElement = null;
        break;
      }
      case 'CheckedBy': {
        newMetaElement = '2';
        break;
      }
      case 'Shipment_ID': {
        newMetaElement = null;
        break;
      }
      case 'Customer_ID': {
        newMetaElement = null;
        break;
      }
      case 'OrderNumber': {
        newMetaElement = null;
        break;
      }
      case 'OrderDate': {
        newMetaElement = null;
        break;
      }
      case 'DeliveryDate': {
        newMetaElement = null;
        break;
      }
      case 'OrderKind': {
        newMetaElement = null;
        break;
      }
      case 'RetailPriceMaintainance': {
        newMetaElement = null;
        break;
      }
      case 'Function': {
        newMetaElement = null;
        break;
      }
      case 'ResponsiblePerson': {
        newMetaElement = null;
        break;
      }
      case 'TransmissionDate': {
        newMetaElement = null;
        break;
      }
      case 'SavingDate': {
        newMetaElement = null;
        break;
      }
      case 'Option1': {
        newMetaElement = '5';
        break;
      }
      case 'Option2': {
        newMetaElement = '6';
        break;
      }
      case 'Option3': {
        newMetaElement = '7';
        break;
      }
      case 'Option4': {
        newMetaElement = '8';
        break;
      }
      case 'Option5': {
        newMetaElement = '9';
        break;
      }
      case 'Option6': {
        newMetaElement = '10';
        break;
      }
      case 'Option7': {
        newMetaElement = '11';
        break;
      }
      case 'Option8': {
        newMetaElement = '12';
        break;
      }
      case 'Option9': {
        newMetaElement = null;
        break;
      }
      case 'Option10': {
        newMetaElement = null;
        break;
      }
      default: {
        newMetaElement = null;
        break;
      }
    }
    return newMetaElement;
  }

  public static setLabelForMultiLine(
    currentLabels: any[],
    textureAreaUsages: TextureAreaUsageVO[],
    toDeleteLabel: any[],
    globalToDeleteLabel: any[],
    textSizeCheckManager: TextSizeCheckManager,
    spacingData,
    textSizeCheckClass: string,
    articleLength: number,
    rotateText: boolean = false,
    onMarkerCarrier: boolean = false
  ): boolean {
    const stripCountPosition: number[] = this.findStripCountPosition(textureAreaUsages);
    const keyArray: any[] = [];
    for (const rowKey of currentLabels) {
      keyArray.push(currentLabels.indexOf(rowKey).toString());
    }
    if (!rotateText) {
      keyArray.reverse();
    }
    let textsizeCheckFound: boolean = true;
    while (keyArray.length > 0) {
      const key: string = keyArray.pop();
      const row: any[] = this.deleteMarkedLabels(currentLabels[key], toDeleteLabel, globalToDeleteLabel);
      if (!row) {
        continue;
      }
      const multiLineCount: number = this.dictionaryLength(currentLabels);
      for (let colIndex = 0; colIndex < row.length; colIndex++) {
        const textureAreaUsage: TextureAreaUsageVO = textureAreaUsages[colIndex];
        if (textureAreaUsage && textureAreaUsage.nextMergedUsageId && !textureAreaUsage.previousMergedUsageId) {
          if (textureAreaUsage.textValue instanceof SimpleTextValueVO) {
            textureAreaUsage.textValue = new TableTextValueVO();
          }
          const currentTableTextValue: TableTextValueVO = textureAreaUsage.textValue as TableTextValueVO;
          currentTableTextValue.rows = [];
          const rowsTableTextValue: TableTextRowVO[] = currentTableTextValue.rows;
          let currentRow: TableTextRowVO = new TableTextRowVO();
          currentRow.items = [];
          rowsTableTextValue.push(currentRow);
          if (stripCountPosition[colIndex]) {
            const strip_count: number = stripCountPosition[colIndex];
            let spannedUntilZIndex: number = -1;
            for (let z: number = 0; z < strip_count; z++) {
              let label: any;
              label = row[colIndex + z];
              if (label) {
                if (onMarkerCarrier && (colIndex === 0 || colIndex === textureAreaUsages.length - 1)) {
                  if (spacingData && !isNaN(spacingData.spacing)) {
                    label.textCheckSpacingData = spacingData;
                  }
                }
                let labelStripCount: number = Number(label.stripeCount);
                labelStripCount -= this.getCountOfSpannedDeletedLabels(toDeleteLabel, label, globalToDeleteLabel);
                const fontData: any = this.getFontSizeAndCompressionByTextSizeCheck(
                  label,
                  multiLineCount,
                  labelStripCount,
                  textSizeCheckManager,
                  spacingData,
                  textSizeCheckClass,
                  articleLength
                );
                if (fontData) {
                  label.fontsize = fontData.fontSize;
                } else {
                  textsizeCheckFound = false;
                }
                const simpleTextValue: CompressionSimpleTextValueVO = this.createTextValue(label, rotateText, true) as CompressionSimpleTextValueVO;
                simpleTextValue.autoCompression = true;
                simpleTextValue.autoFontSize = true;
                simpleTextValue.compression = fontData == null ? 100 : fontData.compression;
                if (label.val !== '' || z > spannedUntilZIndex) {
                  const tableTextItem: TableTextItemVO = new TableTextItemVO();
                  tableTextItem.value = simpleTextValue;
                  spannedUntilZIndex = z + Math.max(labelStripCount - 1, 0);
                  if (labelStripCount > 0 && this.dictionaryLength(currentLabels) === 2) {
                    tableTextItem.colSpan = labelStripCount;
                    tableTextItem.rowSpan = 3;
                  } else if (labelStripCount === 0 && this.dictionaryLength(currentLabels) === 2) {
                    tableTextItem.colSpan = 1;
                    tableTextItem.rowSpan = 3;
                  } else if (labelStripCount > 0 && this.dictionaryLength(currentLabels) === 3) {
                    tableTextItem.colSpan = labelStripCount;
                    tableTextItem.rowSpan = 2;
                  } else if (labelStripCount === 0 && this.dictionaryLength(currentLabels) === 3) {
                    tableTextItem.colSpan = 1;
                    tableTextItem.rowSpan = 2;
                  }
                  if (!currentRow) {
                    currentRow = new TableTextRowVO();
                    currentRow.items = [];
                    currentRow.items.push(tableTextItem);
                    rowsTableTextValue.push(currentRow);
                  } else {
                    currentRow.items.push(tableTextItem);
                  }
                }
              }
            }
            colIndex = colIndex + strip_count;
            colIndex = colIndex - 1;
          }
        } else if (textureAreaUsage && !textureAreaUsage.nextMergedUsageId && !textureAreaUsage.previousMergedUsageId) {
          const label: any = row[colIndex];
          if (label) {
            if (onMarkerCarrier && (colIndex === 0 || colIndex === textureAreaUsages.length - 1)) {
              if (spacingData && !isNaN(spacingData.spacing)) {
                label.textCheckSpacingData = spacingData;
              }
            }
            const fontData: any = this.getFontSizeAndCompressionByTextSizeCheck(
              label,
              multiLineCount,
              1,
              textSizeCheckManager,
              spacingData,
              textSizeCheckClass,
              articleLength
            );
            if (fontData) {
              label.fontsize = fontData.fontSize;
            } else {
              textsizeCheckFound = false;
            }
            const simpleTextValue: CompressionSimpleTextValueVO = this.createTextValue(label, rotateText, true) as CompressionSimpleTextValueVO;
            simpleTextValue.autoCompression = true;
            simpleTextValue.autoFontSize = true;
            simpleTextValue.compression = !fontData ? 100 : fontData.compression;
            const tableTextItem: TableTextItemVO = new TableTextItemVO();
            tableTextItem.value = simpleTextValue;
            const tableTextRow: TableTextRowVO = new TableTextRowVO();
            tableTextRow.items = [];
            tableTextRow.items.push(tableTextItem);
            if (this.dictionaryLength(currentLabels) === 2) {
              tableTextItem.rowSpan = 3;
              tableTextItem.colSpan = 1;
            } else if (this.dictionaryLength(currentLabels) === 3) {
              tableTextItem.rowSpan = 2;
              tableTextItem.colSpan = 1;
            } else {
              tableTextItem.rowSpan = 2;
              tableTextItem.colSpan = 1;
            }
            if (textureAreaUsage.textValue instanceof SimpleTextValueVO) {
              textureAreaUsage.textValue = new TableTextValueVO();
              const tableTextValue: TableTextValueVO = textureAreaUsage.textValue as TableTextValueVO;
              tableTextValue.rows = [];
              tableTextValue.rows.push(tableTextRow);
            } else {
              const tableTextValue: TableTextValueVO = textureAreaUsage.textValue as TableTextValueVO;
              tableTextValue.rows = [];
              tableTextValue.rows.push(tableTextRow);
            }
          }
        }
      }
    }
    return textsizeCheckFound;
  }

  public static setLabelWithOneLine(
    currentLabels: any[],
    textureAreaUsages: TextureAreaUsageVO[],
    toDeleteLabel: any[],
    globalToDeleteLabel: any[],
    textSizeCheckManager: TextSizeCheckManager,
    spacingData,
    textSizeCheckClass: string,
    articleLength: number,
    rotateText: boolean = false
  ): boolean {
    let textsizeCheckFound: boolean = true;
    for (const itemsKey in currentLabels) {
      if (currentLabels.hasOwnProperty(itemsKey)) {
        const currentItemLabels: any[] = currentLabels[itemsKey];
        const itemLabels: any[] = this.deleteMarkedLabels(currentItemLabels, toDeleteLabel, globalToDeleteLabel);
        if (itemLabels) {
          let count: number = 0;
          for (let y: number = 0; y < textureAreaUsages.length; y++) {
            const label: any = itemLabels[count];
            if (!label) {
              continue;
            }
            let labelStripCount: number = Number(label.stripeCount);
            labelStripCount -= this.getCountOfSpannedDeletedLabels(toDeleteLabel, label, globalToDeleteLabel);
            const currentTextureAreaUsage: TextureAreaUsageVO = textureAreaUsages[y];
            if (y === 0 || y === textureAreaUsages.length - 1) {
              if (spacingData && !isNaN(spacingData.spacing)) {
                label.textCheckSpacingData = spacingData;
              }
            }
            const simpleTextValue: CompressionSimpleTextValueVO = this.createTextValue(label, rotateText, true) as CompressionSimpleTextValueVO;
            const multiLineCount: number = 1;
            const fontData: any = this.getFontSizeAndCompressionByTextSizeCheck(
              label,
              multiLineCount,
              labelStripCount,
              textSizeCheckManager,
              spacingData,
              textSizeCheckClass,
              articleLength
            );
            if (fontData) {
              label.fontsize = fontData.fontSize;
            } else {
              textsizeCheckFound = false;
            }
            currentTextureAreaUsage.textValue = simpleTextValue;
            if (currentTextureAreaUsage.textValue instanceof CompressionSimpleTextValueVO) {
              currentTextureAreaUsage.textValue.autoFontSize = true;
              currentTextureAreaUsage.textValue.autoCompression = true;
              currentTextureAreaUsage.textValue.compression = !fontData ? 100 : fontData.compression;
            }
            count++;
          }
        }
      }
    }
    return textsizeCheckFound;
  }

  public static createTextValue(label: any, rotateText: boolean, isCompressedText: boolean): SimpleTextValueVO {
    if (!label) {
      return null;
    }
    let textValue: SimpleTextValueVO;
    if (isCompressedText) {
      textValue = new CompressionSimpleTextValueVO();
    } else {
      textValue = new SimpleTextValueVO();
    }
    textValue.text = this.createFlexHtmlForLabelObject(label);
    switch (label.rotation) {
      case '1': {
        if (rotateText) {
          textValue.rotation = 90;
        } else {
          textValue.rotation = 270;
        }
        break;
      }
      case '2': {
        if (rotateText) {
          textValue.rotation = 180;
        } else {
          textValue.rotation = 0;
        }
        break;
      }
      case '3': {
        if (rotateText) {
          textValue.rotation = 270;
        } else {
          textValue.rotation = 90;
        }
        break;
      }
      case '4': {
        if (rotateText) {
          textValue.rotation = 0;
        } else {
          textValue.rotation = 180;
        }
        break;
      }
    }
    return textValue;
  }

  public static findStripCountPosition(textureAreaUsages: TextureAreaUsageVO[]): number[] {
    const stripCountPostion: number[] = [];
    if (!textureAreaUsages) {
      return stripCountPostion;
    }
    let currentStripCount: number = 1;
    for (let i: number = 0; i < textureAreaUsages.length; i++) {
      const textureAreaUsage: TextureAreaUsageVO = textureAreaUsages[i];
      if (!textureAreaUsage.nextMergedUsageId) {
        stripCountPostion[i - currentStripCount + 1] = currentStripCount;
        currentStripCount = 1;
      } else {
        currentStripCount++;
      }
    }
    return stripCountPostion;
  }

  // NGI-362
  private static getFontSizeAndCompressionByTextSizeCheck(
    label: any,
    multiLineCount: number,
    amountOfMergedCells: number,
    textSizeCheckManager: TextSizeCheckManager,
    parentSpacingData: TextCheckSpacingData,
    textSizeCheckClass: string,
    articleLength: number
  ): any {
    if (!(textSizeCheckManager || label)) {
      return null;
    }
    amountOfMergedCells = Math.max(amountOfMergedCells, 1);
    let averageSpacing: number = -1;
    if (amountOfMergedCells > 1 && articleLength > 0) {
      averageSpacing = articleLength / amountOfMergedCells;
    }
    const linesWithText: string[] = TextSizeCheckUtils.getLinesWithText(label.val);
    const lines: number = !linesWithText ? 0 : linesWithText.length;
    const chars: number = TextSizeCheckUtils.getMaxSizeTextInLines(linesWithText);
    if (chars === 0) {
      const result: any = new Object();
      result.fontSize = label.fontsize;
      result.compression = 100;
      return result;
    }
    let rotation: number = 0;
    if (label.rotation === '1' || label.rotation === '3') {
      rotation = 1;
    }
    let spacingData: TextCheckSpacingData = parentSpacingData;
    if (label.hasOwnProperty('textCheckSpacingData') && label.textCheckSpacingData) {
      spacingData = label.textCheckSpacingData;
    }
    const textSizeCheckInfos: TextSizeCheckVO[] =
      averageSpacing > 0
        ? textSizeCheckManager.getTextSizeCheckWithDecidingSpacing(textSizeCheckClass, averageSpacing)
        : textSizeCheckManager.getTextSizeCheckWithFallback(textSizeCheckClass, spacingData, articleLength > 0);
    const adjustedMaxCharsInLineForMergedColumns: number = rotation === 0 ? Math.ceil(chars / amountOfMergedCells) : chars;
    const adjustedLinesForMergedColumns: number = rotation === 0 ? lines : Math.ceil(lines / amountOfMergedCells);
    const useScaleFactor: boolean = amountOfMergedCells > 1 && rotation === 0; // NGI-362: Scale factor must only be applied to non-rotated cells
    const compression: number = TextSizeCheckUtils.getLeastCompression(
      textSizeCheckInfos,
      textSizeCheckClass,
      label.fontbold ? 1 : 0,
      adjustedMaxCharsInLineForMergedColumns,
      adjustedLinesForMergedColumns,
      rotation,
      NaN,
      multiLineCount
    );
    const fontSize = TextSizeCheckUtils.getMaxFontSize(
      textSizeCheckInfos,
      textSizeCheckClass,
      label.fontbold ? 1 : 0,
      adjustedMaxCharsInLineForMergedColumns,
      adjustedLinesForMergedColumns,
      rotation,
      compression,
      multiLineCount
    );
    const adjustedCompression: number = TextSizeCheckUtils.getCompressionByParameters(
      textSizeCheckInfos,
      textSizeCheckClass,
      label.fontbold ? 1 : 0,
      adjustedMaxCharsInLineForMergedColumns,
      adjustedLinesForMergedColumns,
      rotation,
      multiLineCount,
      NaN,
      useScaleFactor
    );
    if (isNaN(fontSize) || isNaN(adjustedCompression)) {
      return null;
    }
    const result: any = new Object();
    result.fontSize = fontSize;
    result.compression = adjustedCompression;
    return result;
  }

  private static createFlexHtmlForLabelObject(labelObject: any): string {
    if (!labelObject) {
      return HtmlUtils.createLegacyFontParagraph('', { align: '', fontSize: '', color: '#' });
    }
    const lines: any[] = TextSizeCheckUtils.getLinesWithText(labelObject.val, true);
    if (!lines || lines.length === 0) {
      return this.createFlexHtmlForTextInputLineFormLabelObject('', labelObject);
    } else {
      let flexHTML: string = '';
      for (const line of lines) {
        flexHTML += this.createFlexHtmlForTextInputLineFormLabelObject(line, labelObject);
      }
      return flexHTML;
    }
  }

  private static createFlexHtmlForTextInputLineFormLabelObject(line: string, labelObject: any): string {
    let align: string = '';
    const adjustedTextValue: string = this.getTrimmedString(line);
    switch (labelObject.aligment) {
      case '1': {
        align = 'LEFT';
        break;
      }
      case '2': {
        align = 'RIGHT';
        break;
      }
      case '0': {
        align = 'CENTER';
        break;
      }
    }
    return HtmlUtils.createLegacyFontParagraph(adjustedTextValue, {
      align: align,
      fontSize: labelObject.fontsize,
      color: `#${labelObject.rgbcolor}`,
      bold: Boolean(labelObject.fontbold),
      italic: Boolean(labelObject.fontitalic),
      underline: Boolean(labelObject.fontunderline),
    });
  }
}
